// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"external-url-drag__visuallyhidden--tW1Te","focusable":"external-url-drag__focusable--m0Ld1","dragable":"external-url-drag__dragable--W_7tD"};